import { Subject } from 'rxjs';

/** A selectable person from the directory */
export interface PickerPerson {
    id: number;
    name: string;
    initials: string;
    initialsColor: string;
    meta?: string;
    email?: string;
    disabled?: boolean;
    disabledReason?: string;
    /** Tag names applied to this person — used for inline chip display and tri-state tag filtering. */
    tags?: string[];
}

/** Tri-state tag filter modes. */
export type PickerTagFilterMode = 'has' | 'not';

/** A freeform email entry (only when allowFreeformEmail = true) */
export interface PickerEmail {
    email: string;
    valid: boolean;
}

/** Union type for a selected item */
export type PickerSelection =
    | { type: 'person'; person: PickerPerson }
    | { type: 'email'; email: string; valid: boolean };

/** Emitted on search input changes */
export interface PickerSearchEvent {
    term: string;
    abort$: Subject<void>;
}

/** Options passed to MembersService.getMembers() */
export interface PickerMemberOptions {
    status?: string | string[];
    owners?: boolean;
    allTags?: boolean;
    simple?: boolean;
    unitId?: number;
    paymentMethodCount?: boolean;
}

/** Single neutral color for all initials avatars */
export const PICKER_AVATAR_COLOR = '#8796A9';

/** Map a Membership model to a PickerPerson */
export function mapMembershipToPicker(m: any): PickerPerson {
    const name = `${m.profile?.givenNames ?? ''} ${m.profile?.familyName ?? ''}`.trim() || m.name || '';
    const initials = name.split(' ').map((n: string) => n[0]).filter(Boolean).join('').toUpperCase().slice(0, 2);
    const email = m.user?.email ?? '';
    const tags: string[] = Array.isArray(m.tags)
        ? m.tags.map((t: any) => t?.tag).filter((t: any): t is string => typeof t === 'string' && t.length > 0)
        : [];
    return {
        id: m.id,
        name,
        initials,
        initialsColor: PICKER_AVATAR_COLOR,
        meta: email,
        email,
        tags,
    };
}
